// 洗濯表示パネルの表示行変換と、洗濯記号マスタ検索の遷移制御をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createHinbanWashPanelService(deps) {
    const {
        DicVal,
        GridApi,
        GridData,
        HINBAN_MASTER_SEARCH_CHANGE_URL,
        HINBAN_WASH_PANEL_TYPE,
        HINBAN_WASH_STP_SEARCH_CHANGE_URL,
        HINBAN_WASH_STP_SEARCH_DATAID,
        SetGridData,
        changeurl,
        dispatch,
        entrydataRef,
        entrylock,
        fixedHinbanGenkaDisplayRows,
        fnc,
        isEmpty,
        isHinbanGenkaPanel,
        layoutlock,
        setchangeurl,
        washStpSearchChangeUrlBackupRef,
        washStpSearchRoutingActiveRef
    } = deps;

    function isHinbanWashPanel(panelInfo) {
        return String(DicVal(panelInfo, 'type', '')).trim() === HINBAN_WASH_PANEL_TYPE;
    }
    function createHinbanWashDisplayRow(source = {}) {
        const next = { ...(source || {}) };
        next.rowid = String(DicVal(next, 'rowid', '0') || '0');
        for (let i = 1; i <= 7; i++) {
            const markKey = 'mark' + i;
            const stpKey = 'STP_SENTAKU' + i;
            next[markKey] = String(DicVal(next, markKey, DicVal(next, stpKey, '')) ?? '');
        }
        return next;
    }
    function buildHinbanWashDisplayRows(rows) {
        const sourceRows = Array.isArray(rows) ? rows : [];
        if (sourceRows.length === 0) return [createHinbanWashDisplayRow()];
        return [createHinbanWashDisplayRow(sourceRows[0])];
    }
    function buildHinbanWashSaveRows(rows) {
        const sourceRows = Array.isArray(rows) ? rows : [];
        if (sourceRows.length === 0) return [];
        const source = { ...(sourceRows[0] || {}) };
        for (let i = 1; i <= 7; i++) {
            const markKey = 'mark' + i;
            const stpKey = 'STP_SENTAKU' + i;
            source[stpKey] = String(DicVal(source, markKey, DicVal(source, stpKey, '')) ?? '');
            delete source[markKey];
        }
        source.rowid = String(DicVal(source, 'rowid', '0') || '0');
        return [source];
    }
    function isSearchMasterListChangeUrl(value) {
        return typeof value === 'string' && value.toLowerCase().indexOf('common/getsearchmasterlist=') === 0;
    }
    function sameChangeUrl(left, right) {
        return typeof left === 'string' && typeof right === 'string' && left.toLowerCase() === right.toLowerCase();
    }
    function createHinbanMasterSearchChangeUrl(baseChangeUrl) {
        const source = Array.isArray(baseChangeUrl) ? [...baseChangeUrl] : [];
        const filtered = source.filter((value) => !isSearchMasterListChangeUrl(value));
        filtered.push(HINBAN_MASTER_SEARCH_CHANGE_URL);
        return filtered;
    }
    function createWashStpSearchChangeUrl(baseChangeUrl) {
        const source = Array.isArray(baseChangeUrl) ? [...baseChangeUrl] : [];
        const filtered = source.filter((value) => !isSearchMasterListChangeUrl(value));
        filtered.push(HINBAN_WASH_STP_SEARCH_CHANGE_URL);
        return filtered;
    }
    function restoreWashStpSearchChangeUrl() {
        if (!washStpSearchRoutingActiveRef.current) return;
        dispatch(setchangeurl(washStpSearchChangeUrlBackupRef.current));
        washStpSearchRoutingActiveRef.current = false;
    }
    function routeWashStpSearchChangeUrl() {
        washStpSearchChangeUrlBackupRef.current = Array.isArray(changeurl) ? [...changeurl] : [];
        dispatch(setchangeurl(createWashStpSearchChangeUrl(washStpSearchChangeUrlBackupRef.current)));
        washStpSearchRoutingActiveRef.current = true;
    }
    function buildWashStpSearchDataInfo() {
        return {
            datatype: '5',
            dataid: HINBAN_WASH_STP_SEARCH_DATAID,
            dataidctrl: 'M_STP',
            mastertype: 'M_STP',
            keyinfo: 'STP_CODE',
            keyfield: 'STP_CODE',
            keycolumn: 'STP_CODE',
            columnid: 'STP_CODE',
            dbcolumn: 'STP_CODE',
            dbcolumnnm: 'STP_NAME',
            columnnm: '絵表示パターンコード',
            primary: false,
            multiple: false,
            type: HINBAN_WASH_PANEL_TYPE
        };
    }
    function applyWashStpMasterSelection(panelInfo, result) {
        const row = DicVal(result, 'rowdata', DicVal(result, 'data', {})) || {};
        const items = Array.isArray(DicVal(result, 'items', [])) ? DicVal(result, 'items', []) : [];
        const item = items.length !== 0 ? (DicVal(items[0], 'data', items[0]) || {}) : {};
        const source = !isEmpty(item) ? item : row;
        const code = String(DicVal(source, 'STP_CODE', DicVal(source, 'code', '')) ?? '').trim();
        if (code === '') return;
        const currentRows = Array.isArray(GridData(panelInfo)) ? GridData(panelInfo) : [];
        const base = currentRows.length === 0 ? createHinbanWashDisplayRow() : { ...(currentRows[0] || {}) };
        base.rowid = String(DicVal(base, 'rowid', '0') || '0');
        base.SSDE_STPCD = code;
        base.SSDE_STPCD_cd = code;
        base.SSDE_STPCD_nm = String(DicVal(source, 'STP_NAME', DicVal(source, 'name', code)) ?? code);
        for (let i = 1; i <= 7; i++) {
            const stpKey = 'STP_SENTAKU' + i;
            const markKey = 'mark' + i;
            const value = String(DicVal(source, stpKey, DicVal(base, stpKey, '')) ?? '');
            base[stpKey] = value;
            base[markKey] = value;
        }
        setEntryGridRows(panelInfo, [base]);
        fnc.current.modify(true);
    }
    function openWashStpMasterSearch(panelInfo) {
        if (entrylock || layoutlock) return;
        const datainfo = buildWashStpSearchDataInfo();
        routeWashStpSearchChangeUrl();
        fnc.current.searchlistopen({
            label: DicVal(datainfo, 'columnnm', '絵表示パターンコード'),
            multiple: false,
            rowmode: false,
            data: datainfo,
            rowdata: {
                ...(entrydataRef.current || {}),
                ...((GridData(panelInfo) || [])[0] || {})
            },
            doApply: (result) => {
                restoreWashStpSearchChangeUrl();
                fnc.current.searchlistclose();
                applyWashStpMasterSelection(panelInfo, result);
            }
        });
    }
    function buildWashGridFunctionRef(panelInfo) {
        const base = fnc.current || {};
        return {
            current: {
                ...base,
                washlistopen: () => openWashStpMasterSearch(panelInfo)
            }
        };
    }
    function setEntryGridRows(panelInfo, rows) {
        if (isEmpty(panelInfo)) return;
        const sourceRows = Array.isArray(rows) ? rows : [];
        const storedRows = isHinbanWashPanel(panelInfo)
            ? buildHinbanWashDisplayRows(sourceRows)
            : sourceRows;
        const displayRows = isHinbanGenkaPanel(panelInfo)
            ? fixedHinbanGenkaDisplayRows(sourceRows)
            : storedRows;
        SetGridData(panelInfo, storedRows);
        const api = GridApi(panelInfo);
        if (!isEmpty(api)) {
            if (typeof api.setGridOption === "function") {
                api.setGridOption("rowData", displayRows);
            } else if (typeof api.setRowData === "function") {
                api.setRowData(displayRows);
            }
            if (typeof api.refreshCells === "function") {
                api.refreshCells({ force: true });
            }
        } else {
        }
    }

    return {
        isHinbanWashPanel,
        createHinbanWashDisplayRow,
        buildHinbanWashDisplayRows,
        buildHinbanWashSaveRows,
        isSearchMasterListChangeUrl,
        sameChangeUrl,
        createHinbanMasterSearchChangeUrl,
        createWashStpSearchChangeUrl,
        restoreWashStpSearchChangeUrl,
        routeWashStpSearchChangeUrl,
        buildWashStpSearchDataInfo,
        applyWashStpMasterSelection,
        openWashStpMasterSearch,
        buildWashGridFunctionRef,
        setEntryGridRows
    };
}
